import Cookies from "js-cookie";
import store from '@/store'
const TokenKey = "Admin-Token";
const tenant = "MERCHANT-ID";
const custEffId = "custEffId";
export function getToken() {
  return Cookies.get(TokenKey);
}

export function setToken(token) {
  return Cookies.set(TokenKey, token);
}

export function setCustEffId(custEffId) {
  return Cookies.set(custEffId, custEffId);
}

export function getCustEffId() {
  return Cookies.get(custEffId);
}

export function removeToken() {
  return Cookies.remove(TokenKey);
}
export function setTenant(merchant_id) {
  return Cookies.set(tenant, merchant_id);
}
export function getTenant() {
  return Cookies.get(tenant);
}
export function removeTenant() {
  return Cookies.remove(tenant);
}
export function checkMenu(path) {
	if (!path) {
		console.warn('请传入检查的路由')
		return
	}
	const routes = store.getters.permission_routes
	let hasMenu = false
	const checkRoutes = function(menuData) {
		for (let index = 0; index < menuData.length; index++) {
			const node = menuData[index];
			if (node.path == path) {
				hasMenu = true
				break
			}
			if (node.children && node.children.length) {
				checkRoutes(node.children)
			}	
		}

	}
	checkRoutes(routes)
	return hasMenu
	
}
